import { render, staticRenderFns } from "./laowu-project-list.vue?vue&type=template&id=aaae2dec&scoped=true"
import script from "./laowu-project-list.vue?vue&type=script&lang=js"
export * from "./laowu-project-list.vue?vue&type=script&lang=js"
import style0 from "./laowu-project-list.vue?vue&type=style&index=0&id=aaae2dec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaae2dec",
  null
  
)

export default component.exports